import {
  FormControl,
  FormLabel,
  Grid,
  GridItem,
  Heading,
  Image,
  Input,
  Select,
  Stack,
} from '@chakra-ui/react'
import { map, startCase } from 'lodash'
import urineType from '../../../../assets/urineType.jpeg'
import { odors, urineColors } from '../../../../types/StoolQuestionnaire'
import { StoolState } from '../utils/types'

interface UrineFormProps {
  state: StoolState
  setState: (state: StoolState) => void
}

export default function UrineForm({ state, setState }: UrineFormProps) {
  return (
    <Grid gap={6} templateColumns='repeat(5, 1fr)'>
      <GridItem colSpan={[5, 2]}>
        <Stack spacing={4} align='start'>
          <Heading size='md'>Urine this Month</Heading>
          <FormControl isRequired>
            <FormLabel>Times per day</FormLabel>
            <Input
              type='number'
              step='any'
              value={state.urine.timesDaily}
              onChange={(e) => {
                setState({
                  ...state,
                  urine: {
                    ...state.urine,
                    timesDaily: parseInt(e.target.value),
                  },
                })
              }}
            />
          </FormControl>
          <FormControl isRequired>
            <FormLabel>Urine Color (from chart)</FormLabel>
            <Select
              placeholder='Choose Color'
              value={state.urine.color}
              onChange={(e) => {
                setState({
                  ...state,
                  urine: {
                    ...state.urine,
                    color: parseInt(e.target.value),
                  },
                })
              }}
            >
              {map(urineColors, (text, key) => {
                return (
                  <option value={key} key={key}>
                    ({key}) {text}
                  </option>
                )
              })}
            </Select>
          </FormControl>
          <FormControl isRequired>
            <FormLabel>Urine Odor</FormLabel>
            <Select
              placeholder='Choose Odor'
              value={state.urine.odor}
              onChange={(e) => {
                setState({
                  ...state,
                  urine: {
                    ...state.urine,
                    odor: e.target.value,
                  },
                })
              }}
            >
              {odors.map((value) => {
                return (
                  <option value={value} key={value}>
                    {startCase(value).split(' ').join('-')}
                  </option>
                )
              })}
            </Select>
          </FormControl>
        </Stack>
      </GridItem>
      <GridItem colSpan={[5, 3]}>
        <Image src={urineType} objectFit='contain' />
      </GridItem>
    </Grid>
  )
}
